// 测试
export const CONTRACT_SELECTION = {
    title: '选择合同数据',
    dialog: 'selection',
    keyField: 'contractId', nameField: 'contractNo', module: 'fmpContract',
    queryFields: ["contractNo", "contractTitle",
        { field: "contractType", relPath: ["contractType.name"] },
        { field: "bizTypeCode", relPath: ["mdmBizType.bizTypeName"] },
        "wbsProjectNo", "batchId"],
    listFields: ["contractNo",
        { field: "contractType", relPath: ["contractType.name"] },
        "contractTitle", "wbsProjectNo", "contractAmount", "signingDate",
        { field: "contractStatus", relPath: ["contractStatus.name"] },
        { field: "bizTypeCode", relPath: ["mdmBizType.bizTypeName"] },
        "batchId"]
}
// 选择电子书
export const EBK_SELECTION = {
    title: '选择电子书',
    dialog: 'selection',
    keyField: 'id', nameField: 'ebookName', module: 'ebkEBook',
    queryFields: ["ebookName"],
    listFields: [
        "ebookName",
                    {
                        "field": "publishingStatus",
                        "relPath": [
                            "publishingStatus.name"
                        ]
                    },
                    {
                        "field": "author",
                        "align": "center",
                        "relPath": [
                            "mdmAuthor.authorName"
                        ]
                    }
    ]
}

export const TATEBK_SELECTION = {
    title: '选择电子书',
    dialog: 'selection',
    keyField: 'id', nameField: 'ebookName', module: 'tatEBook',
    queryFields: ["ebookName",{"field":"isFree","relPath":["yesOrNo.name"]}],
    listFields: [
        "ebookName",
        {"field":"isFree","relPath":["yesOrNo.name"]},
                    {
                        "field": "publishingStatus",
                        "relPath": [
                            "publishingStatus.name"
                        ]
                    },
                    {
                        "field": "author",
                        "align": "center",
                        "relPath": [
                            "mdmAuthor.authorName"
                        ]
                    }
    ]
}

// 章节
export const CHAPTER_SELECTION = {
    title: '选择章节',
    dialog: 'tree',
    keyField: 'id', nameField: 'directoryName', module: 'ebkEBookChapter',
    filter:{ "directoryType": "chapter" },
    queryFields: ["directoryName"],
    listFields: [{ "field": "directoryName", "type":"html-detail","align": "center" }, { "field": "directoryType", "relPath": ["directoryType.name"] }]
}

export const TATCHAPTER_SELECTION = {
    title: '选择章节',
    dialog: 'tree',
    keyField: 'id', nameField: 'directoryName', module: 'tatEBookChapter',
    queryFields: ["directoryName"],
    listFields: [{ "field": "directoryName", "type":"html-detail", "align": "center" }, { "field": "directoryType", "relPath": ["directoryType.name"] }]
}
// 图书分类
export const CATALOG_TREE_SELECTION = {
    title: '选择图书分类',
    dialog: 'tree',
    keyField: 'id', nameField: 'bookClassifyName', parentField: 'parentId', module: 'ebkBookClassify', 
    addAll: false,
    queryFields: ["bookClassifyName"],
    listFields: [{ "field": "bookClassifyName", "align": "center" }]
}
// 图书分类
export const TATCATALOG_SELECTION = {
    title: '选择图书分类',
    dialog: 'tree',
    keyField: 'id', nameField: 'bookClassifyName', parentField: 'parentId', module: 'tatBookClassify',
    addAll: false,
    queryFields: ["bookClassifyName"],
    listFields: [{ "field": "bookClassifyName", "align": "center" }]
}
// 商品分类
export const SHOP_TREE_SELECTION = {
    title: '选择商品分类',
    dialog: 'tree',
    keyField: 'id', nameField: 'goodsCategoryName', parentField: 'parentId', module: 'tatGoodsCategory',width:800,
    addAll: false,
    queryFields: [{ "field": "goodsCategoryName", "width": 16}],
    listFields: [{ "field": "goodsCategoryName", "align": "center" }]
}
// 选择知识
export const KNOW_SELECTION = {
    title: '选择知识点',
    dialog: 'selection',
    keyField: 'id', nameField: 'knowledgeName', module: 'kbsKnowledgePoint',
    queryFields: ["knowledgeName"],
    tree: {
        "view": {
            "module": "kbsKnowledgeCategory"
        },
        "queryUr1": "",
        "filter": "",
        "keyField": "id",
        "parentField": "parentId",
        "nameField": "knowledgeCategoryName",
        "filterFields": ["id"],
        "withChildren": true
    },
    listFields: ["knowledgeName",
        {
            "field": "knowledgeDesc",
            "type": "detail"
        }]
}
// 资源文件
export const RESOURCE_SELECTION = {
    title: '选择资源文件',
    dialog: 'selection',
    keyField: 'id', nameField: 'fileName', module: 'ebkResource',
    filter:{ "auditStatus": "pass" },
    queryFields: [{ "field": "fileName", "width": 16 }],
    listFields: [{"field":"resourceType","relPath":["resourceType.name"]},{ "field": "fileName", "align": "center" },{ "field": "fastNo", "align": "center" }]
}

// 资源文件
export const TATRESOURCE_SELECTION = {
    title: '选择资源',
    dialog: 'selection',
    width:900,
    keyField: 'id', nameField: 'fileName', module: 'tatResource',
    filter:{ "auditStatus": "pass" },
    queryFields: [{ "field": "fileName", "width": 16 },{ "field": "isFree","relPath":["yesOrNo.name"],"width":8  }],
    listFields: [{"field":"resourceType","relPath":["resourceType.name"]},{ "field": "fileName", "align": "center" },{ "field": "isFree","relPath":["yesOrNo.name"] },{ "field": "fastNo", "align": "center" }]
}

// 参考文献
export const RESOURCE_REF_SELECTION = {
    title: '选择参考文献',
    dialog: 'selection',
    width:800,
    filter:{ "resourceType": "references","auditStatus": "pass" },
    keyField: 'id', nameField: 'fileName', module: 'ebkResource',
    queryFields: [{ "field": "fileName", "width": 16 }],
    listFields: [{ "field": "fileName", "align": "center" },{ "field": "fastNo", "align": "center" }]
}

// 参考文献
export const TATRESOURCE_REF_SELECTION = {
    title: '选择参考文献',
    dialog: 'selection',
    width:800,
    filter:{ "resourceType": "references" },
    keyField: 'id', nameField: 'fileName', module: 'tatResource',
    queryFields: [{ "field": "fileName", "width": 16 }],
    listFields: [{ "field": "fileName", "align": "center" },{ "field": "size", "align": "center" }]
}

export const TERM_SELECTION = {
    title: '选择术语',
    dialog: 'selection',
    keyField: 'id', nameField: 'termChName', module: 'kbsTerm',
    queryFields: ["termChName"],
    listFields: [{
        "field":"termChName",
        "align":"center"
    },
    {
        "field":"termEnName",
        "align":"center"
    },
    {
        "field":"termNickname",
        "align":"center"
    },
    {
        "field":"termDesc",
        "type":"detail"
    }]
}
// 知识分类
export const CATEGORY_SELECTION = {
    title: '选择知识分类',
    dialog: 'tree',
    keyField: 'id', nameField: 'knowledgeCategoryName', module: 'kbsKnowledgeCategory', 
    addAll: false,
    queryFields: ["knowledgeCategoryName"],
    listFields: [{ "field": "knowledgeCategoryName", "align": "center" },{ "field": "createBy", "name": "创建人" },{ "field": "createTime", "align": "创建时间" }]
}

// 知识分类
export const TATKNOW_SELECTION = {
    title: '选择知识分类',
    dialog: 'tree',
    keyField: 'id', nameField: 'knowledgeCategoryName', module: 'tatKnowledgeCategory', width: 800,
    addAll: false,
    queryFields: ["knowledgeCategoryName"],
    listFields: [{ "field": "knowledgeCategoryName", "align": "center" }]
}


export const AUTHOR_SELECTION = {
    title: '选择作者',
    dialog: 'selection',
    keyField: 'id', nameField: 'authorName', module: 'mdmAuthor',
    addAll: false,
    queryFields: ["authorName"],
    listFields: [{ "field": "authorName", "align": "center" },
    { "field": "politicalOrientation", "relPath": ["politicalOrientation.name"] }, {"field": "researchDirection","type":"detail"}, {"field": "researchField","type":"detail"}
    ]
}

export const TATAUTHOR_SELECTION = {
    title: '选择作者',
    dialog: 'selection',
    keyField: 'id', nameField: 'authorName', module: 'tatAuthor',
    addAll: false,
    queryFields: ["authorName"],
    listFields: [{ "field": "authorName", "align": "center" },
    { "field": "politicalOrientation", "relPath": ["politicalOrientation.name"] }, {"field": "researchDirection","type":"detail"}, {"field": "researchField","type":"detail"}
    ]
}
export const MODEL_SELECTION = {
    title: '选择实体',
    dialog: 'selection',
    keyField: 'id', nameField: 'name', module: 'sysModelEntity', width: 800,
    filter:{ "code": ["tatEBookChapter","tatEBook"] },
    addAll: false,
    queryFields: ["name"],
    listFields: [{ "field": "name", "align": "center","name":"名称" }]
}

export const ADDRESS_SELECTION = {
    title: '选择地区',
    dialog: 'tree',
    keyField: 'id', nameField: 'name', module: 'mdmRegion', width: 800,
    addAll: false,
    queryFields: ["name"],
    listFields: [{ "field": "name", "align": "center","name":"地区名称" }]
}

// 选择能力分类
export const ABILITY_SELECTION = {
    title: '选择能力分类',
    dialog: 'tree',
    keyField: 'id', nameField: 'abilityFullName', parentField: 'parentId', module: 'kbsAbilityCategory',
    addAll: false,
    queryFields: ["abilityFullName"],
    listFields: ["abilityFullName"]
}
// 选择能力分类
export const TATABILITY_SELECTION = {
    title: '选择能力分类',
    dialog: 'selection',
    keyField: 'id', nameField: 'abilityFullName', parentField: 'parentId', module: 'kbsAbilityCategory',
    addAll: false,
    queryFields: ["abilityFullName"],
    listFields: ["abilityFullName"]
}

export const BUNDLE_SELECTION = {
    title: '选择商品',
    dialog: 'selection',
    keyField: 'id', nameField: 'goodsTitle', module: 'tatGoods',
    addAll: false,
    queryFields: ["goodsTitle"],
    listFields: [{ "field": "goodsTitle", "align": "center" },"goodsSubtitle","minSalesPrice","maxSalesPrice","aftermarketValidity","serviceValidity"
    ]
}

// 选择能力分类
export const TATKNOWLIST_SELECTION = {
    title: '选择知识点',
    dialog: 'selection',
    keyField: 'id', nameField: 'knowledgeName', module: 'tatKnowledgePoint',
    addAll: false,
    queryFields: ["knowledgeName"],
    listFields: ["knowledgeName",
{
    "field":"knowledgeDesc",
    "type":"detail"
}]
}
// 选择评估指标
export const ESTIMATE_SELECTION = {
    title: '选择评估指标',
    dialog: 'selection',
    keyField: 'id', nameField: 'evaluateIndexName', module: 'kbsEvaluateIndex',
    addAll: false,
    queryFields: ["evaluateIndexName"],
    listFields: ["evaluateIndexName",{
        "field": "createBy",
        "name": "创建人"
    },
    {
        "field": "createTime",
        "name": "创建时间"
    }]
}


// 选中证书类型
export const CERTCATEGORY_SELECTION = {
    title: '选择证书类型',
    dialog: 'selection',
    keyField: 'id', nameField: 'certCategoryName', module: 'tatCertCategory',
    addAll: false,
    queryFields: ["certCategoryName"],
    listFields: [{ "field": "certCategoryName", "align": "center" },"certRule"
    ]
}
export const POST_SELECTION = {
    title: '选择岗位',
    dialog: 'selection',
    keyField: 'id', nameField: 'postName', module: 'sysPost',
    addAll: false,
    queryFields: ["postName"],
    listFields: [{ "field": "postName", "align": "center" },"postSort",{
        "field": "createBy",
        "name": "创建人"
    },
    {
        "field": "createTime",
        "name": "创建时间"
    }]
}
// 医护
export const USER_SELECTION = {
    title: '选择用户',
    dialog: 'selection',
    keyField: 'userId', nameField: 'nickName', module: 'sysUser',
    queryFields: ["nickName"],
    listFields: [
        "userName",
        "nickName"]
}
// C端用户
export const CENDUSER_SELECTION = {
    title: '选择用户',
    dialog: 'selection',
    keyField: 'userId', nameField: 'nickName', module: 'cendUser',
    queryFields: ["nickName"],
    listFields: [
        "userName",
        "nickName"]
}
// 部门
export const DEPT_SELECTION = {
    title: '选择部门',
    dialog: 'selection',
    keyField: 'id', nameField: 'deptName', parentField: 'parentId', module: 'sysDept',
    queryFields: ["deptName"],
    listFields: [
        "deptName",
        "leader",
        {
            "field": "createBy",
            "name": "创建人"
        },
        {
            "field": "createTime",
            "name": "创建时间"
        }]
}
// 机构
export const COMPANY_SELECTION = {
    title: '选择机构',
    dialog: 'selection',
    keyField: 'id', nameField: 'medicalUnitName', module: 'mdmCompany',
    queryFields: ["medicalUnitName"],
    listFields: [
        "medicalUnitName",
        "hospitalGrade",{"field":"isAyHospital","relPath":["yesOrNo.name"]}]
}
export const ROLE_SELECTION = {
    title: '关联角色',
    dialog: 'selection',
    selectType: 2,
    keyField: 'roleId', nameField: 'roleName', module: 'sysRole',
    filter:{},
    queryFields: ["roleName"],
    listFields: [
        "roleName","roleKey","remark"]
}